import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomNavbar from "../../../components/CustomNavbar";
// import SidebarCapacitacion from "../../../components/capacitacionDesarrollo/SidebarCapacitacion";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  // OverlayTrigger,
  // Tooltip,
  // Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
// import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";

//redux
import {
  getMetricNineBoxes,
  saveMetricNineBoxes,
  editMetricNineBoxes,
  deleteMetricNineBoxes,
  resetMetricNineBoxes,
} from "../../../redux/capacitacionDesarrollo/MetricNineBoxes/actions";
import SidebarNueveCajas from "../../../components/nueveCajas/SidebarNueveCajas";
// import { HexColorPicker } from "react-colorful";

const MetricNineBoxes = (props) => {
  const fecha = new Date();
  var n = fecha.getFullYear();

  const tipoCriterio = [
    { id: 1, desc: "Desempeño", color: "#49E52D" },
    { id: 2, desc: "Potecial", color: "#2B33EA" },
  ];

  const cordenada = [
    { id: 1, desc: 1 },
    { id: 2, desc: 2 },
    { id: 3, desc: 3 },
  ];

  // Tipo de busqueda para filter
  // const filters = [
  //   { id: "descripcion", desc: "Métrica" },
  //   { id: "valor_minimo", desc: "Valor Mínimo" },
  //   { id: "valor_maximo", desc: "Valor Máximo" },
  //   { id: "tipo_criterio", desc: "Tipo de criterio" },
  // ];

  // Variables de hooks
  const [show, setShow] = useState(true);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState(1);
  const [_anio, setAnio] = useState(n);
  const [inicialValorMinimo, setInicialValorMinimo] = useState(0);
  const [inicialValorMinimoEdit, setInicialValorMinimoEdit] = useState(0);
  // const [tipoBusqueda, setTipoBusqueda] = useState({
  //   id: "descripcion",
  //   desc: "Métrica",
  // });

  // Shema de Yup
  const schema = Yup.object().shape({
    descripcion: Yup.string().ensure().required("**Campo requerido"),
    tipo_criterio: Yup.string().required("**Campo requerido"),
    cordenada: Yup.string().required("**Campo requerido"),
    valor_minimo: Yup.number()
      .integer("**El número no puede tener decimales.")
      .min(0, "**El valor minimo es 0.")
      .max(100, "**El valor maximo es 100.")
      .required("**Campo requerido"),
    valor_maximo: Yup.number()
      .integer("**El número no puede tener decimales.")
      .min(
        !edit ? inicialValorMinimo + 1 : inicialValorMinimoEdit + 1,
        `**El valor minimo es ${
          !edit ? inicialValorMinimo + 1 : inicialValorMinimoEdit + 1
        }.`
      )
      .max(100, "**El valor maximo es 100.")
      .required("**Campo requerido"),
    anio: Yup.number()
      .integer("**El número no puede tener decimales.")
      .min(2000, "**El valor minimo es 0.")
      .required("**Campo requerido"),
  });

  const dispatch = useDispatch();

  // Variables de redux
  const {
    loaderMetricNineBoxes,
    metricNineBoxes,
    // metricNineBoxesAll,
    metricNineBoxesAnio,
    metricNineBoxesFalla,
    saveloaderMetricNineBoxes,
    metricNineBoxesFormError,
  } = useSelector((store) => store.metricNineBoxes);

  // const pages = Math.ceil(
  //   (metricNineBoxes ? metricNineBoxes.count : 0) / limit
  // );

  // Columnas para custom table
  const columns = [
    {
      Header: "Métrica",
      accessor: "descripcion",
      Filter: "",
    },
    {
      Header: "Valor mínimo",
      accessor: "valor_minimo",
      Filter: "",
    },
    {
      Header: "Valor máximo",
      accessor: "valor_maximo",
      Filter: "",
    },
    {
      Header: "Año",
      accessor: "anio",
      Filter: "",
    },
    {
      Header: "Tipo de criterio:",
      // accessor: "list_estado[0].nombre_estado",
      Filter: "",
      Cell: (value) => (
        <div
          className="py-2 px-3 rounded-pill text-white text-between"
          style={{
            backgroundColor: tipoCriterio.find(
              (e) => e.id === value.row.original.tipo_criterio
            )
              ? tipoCriterio.find(
                  (e) => e.id === value.row.original.tipo_criterio
                ).color
              : "",
            width: "120px",
            height: "35px",
          }}
        >
          {tipoCriterio.find((e) => e.id === value.row.original.tipo_criterio)
            ? tipoCriterio.find(
                (e) => e.id === value.row.original.tipo_criterio
              ).desc
            : ""}
        </div>
      ),
    },
    {
      Header: "Coordenada:",
      // accessor: "list_estado[0].nombre_estado",
      Filter: "",
      Cell: (value) => (
        <div className="py-2 px-3 rounded-pill text-between">
          {cordenada.find((e) => e.id === value.row.original.cordenada)
            ? cordenada.find((e) => e.id === value.row.original.cordenada).desc
            : ""}
        </div>
      ),
    },
    {
      Header: "Fecha de creación",
      accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Metodos
  const _getMetricNineBoxes = (
    offs = offset,
    lim = limit,
    filt = filter,
    ani = _anio
  ) =>
    dispatch(
      getMetricNineBoxes({
        offset: offs,
        limit: lim,
        // tipo_busqueda: tipoBusqueda.id,
        tipo_busqueda: "tipo_criterio",
        filter: filt,
        // tipo_busqueda_2: "anio",
        filter_2: ani, //Ya se identifica filter_2 del lado del back el valor de anio
        // tipoBusqueda.id === "tipo_criterio"
        //   ? "desempeño".includes(filt.toLowerCase())
        //     ? 1
        //     : 2
        //   : filt,
      })
    );

  useEffect(() => {
    // setFilter("");
    // dispatch(resetMetricNineBoxes());
    _getMetricNineBoxes();
  }, []);

  useEffect(() => {
    if (
      metricNineBoxes &&
      metricNineBoxes.data &&
      metricNineBoxes.data[metricNineBoxes.count - 1]
    ) {
      setInicialValorMinimo(
        metricNineBoxes.data[metricNineBoxes.count - 1].valor_maximo + 1
      );
    } else {
      setInicialValorMinimo(0);
    }
  }, [metricNineBoxes]);

  useEffect(() => {
    if (filter !== "" && _anio !== "") {
      const oOffset = 0;
      setOffset(oOffset);
      setCurrentPage(1);
      _getMetricNineBoxes(oOffset, limit, filter, _anio);
    }
  }, [filter, _anio]);

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setInicialValorMinimoEdit(item.valor_minimo);
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onSubmit = (req) => {
    if (
      (!edit &&
        metricNineBoxes &&
        metricNineBoxes.data.find(
          (m) => m.cordenada === parseInt(req.cordenada)
        )) ||
      (edit &&
        metricNineBoxes &&
        metricNineBoxes.data.find(
          (m) =>
            m.cordenada === parseInt(req.cordenada) &&
            editItem.cordenada !== parseInt(req.cordenada)
        ))
    ) {
      toastr.info(
        "Ya existe un registro con este coordenada para el año seleccionado"
      );
      return;
    }
    if (
      (!edit &&
        metricNineBoxes &&
        metricNineBoxes.data.find(
          (m) =>
            m.descripcion === req.descripcion && m.anio === parseInt(req.anio)
        )) ||
      (edit &&
        metricNineBoxes &&
        metricNineBoxes.data.find(
          (m) =>
            m.descripcion === req.descripcion && m.anio === parseInt(req.anio)
        ) &&
        metricNineBoxes.data.find(
          (m) =>
            m.descripcion === req.descripcion && m.anio === parseInt(req.anio)
        ).id !== editItem.id)
    ) {
      toastr.info(
        "Ya existe un registro con este nombre para el año seleccionado"
      );
      return;
    }
    if (
      !edit &&
      metricNineBoxes &&
      metricNineBoxes.data.filter((m) => m.anio === parseInt(req.anio))
        .length === 3
    ) {
      toastr.info(
        "Ya se han agregado 3 registros para este tipo para el año seleccionado"
      );
      return;
    }
    if (parseInt(req.valor_minimo) >= parseInt(req.valor_maximo)) {
      toastr.info("El valor mínimo no puede ser mayor o igual al valor máximo");
      return;
    }

    if (!edit && metricNineBoxes && metricNineBoxes.count === 3) {
      toastr.info("Solo puede agregar 3 registros para este tipo");
      return;
    }

    if (!edit) {
      dispatch(
        saveMetricNineBoxes(req, setShowFormModal, setInicialValorMinimo)
      );
    } else {
      req.id = editItem.id;
      dispatch(editMetricNineBoxes(req, index, setShowFormModal, offset));
    }
  };

  // const seeAll = () => {
  //   const oSearch = "";
  //   setFilter(oSearch);
  //   const oOffset = 0;
  //   setOffset(oOffset);
  //   setCurrentPage(1);
  //   _getMetricNineBoxes(oOffset, limit, oSearch);
  // };

  // const onSearch = (criterio) => {
  //   // e.preventDefault();
  //   setFilter(criterio);
  //   const oOffset = 0;
  //   setOffset(oOffset);
  //   setCurrentPage(1);
  //   _getMetricNineBoxes(oOffset, limit, criterio);
  // };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteMetricNineBoxes(id, data, offset, setInicialValorMinimo));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarNueveCajas show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              Métrica de 9 cajas
            </h5>
            <Form
            // onSubmit={onSearch}
            >
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                {/* <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col> */}
                <Col xs="auto">
                  <ButtonGroup>
                    {/* <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button> */}
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    {/* <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger> */}
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <Col>
            <Row>
              <Form.Group as={Col} md={5} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Tipo de criterio
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={12}>
                        <Form.Control
                          as="select"
                          id="criterio"
                          name="criterio"
                          className="col rounded-pill"
                          value={filter}
                          onChange={(e) => {
                            e.preventDefault();
                            setFilter(e.currentTarget.value);
                            // onSearch(e.currentTarget.value);
                          }}
                        >
                          {/* <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar criterio
                          </option> */}
                          {tipoCriterio.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.desc}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md={5} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Año
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loaderMetricNineBoxes ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="aniio"
                          name="aniio"
                          className="col rounded-pill"
                          defaultValue={_anio}
                          disabled={
                            loaderMetricNineBoxes ||
                            !metricNineBoxesAnio ||
                            (metricNineBoxesAnio &&
                              metricNineBoxesAnio.data.length === 0)
                          }
                          onChange={(e) => {
                            e.preventDefault();
                            if (e.currentTarget.value !== "") {
                              setAnio(parseInt(e.currentTarget.value));
                            } else {
                              setAnio(n);
                            }
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            // disabled
                          ></option>
                          {metricNineBoxesAnio &&
                            metricNineBoxesAnio.data
                              .sort((a, b) =>
                                a.anio > b.anio ? 1 : b.anio > a.anio ? -1 : 0
                              )
                              .map((item) => (
                                <option key={item.anio} value={item.anio}>
                                  {item.anio}
                                </option>
                              ))}
                        </Form.Control>
                      </Col>
                      {loaderMetricNineBoxes ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Col>
          {!!metricNineBoxesFalla && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {metricNineBoxesFalla}
            </Alert>
          )}
          {loaderMetricNineBoxes ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : metricNineBoxes != null && metricNineBoxes.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={metricNineBoxes.data} />
                </Card.Body>
              </Card>
              {/* <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={metricNineBoxes.count}
                pages={pages}
                pagFunc={_getMetricNineBoxes}
              /> */}
            </>
          ) : (
            <Alert variant="info" className="mt-4 mb-1 mx-2">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>
      </div>
      {/*Modal editar*/}
      <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            descripcion: edit ? editItem.descripcion : "",
            tipo_criterio: edit
              ? editItem.tipo_criterio
                ? editItem.tipo_criterio
                : 1
              : filter,
            valor_minimo: edit ? editItem.valor_minimo : inicialValorMinimo,
            valor_maximo: edit ? editItem.valor_maximo : inicialValorMinimo + 1,
            anio: edit ? editItem.anio : n,
            cordenada: edit ? (editItem.cordenada ? editItem.cordenada : 1) : 1,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            values,
            touched,
            handleBlur,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  {edit ? "Editar Métrica" : "Crear Métrica"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!metricNineBoxesFormError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {metricNineBoxesFormError}
                  </Alert>
                )}
                {filter === "" && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    Debe seleccionar un criterio previamente, para poder agregar
                    un nuevo registro.
                  </Alert>
                )}
                {!edit && _anio !== n && (
                  <Alert variant="info" className="mt-1 mb-2">
                    El año seleccionado previamente, debe ser igual al año
                    seleccionado en el formulario o estar vacio.
                  </Alert>
                )}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Métrica
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      id="descripcion"
                      name="descripcion"
                      isInvalid={touched.descripcion && errors.descripcion}
                      isValid={touched.descripcion && !errors.descripcion}
                      onBlur={handleBlur("descripcion")}
                      onChange={handleChange}
                      value={values.descripcion}
                      className="rounded-pill"
                      type="text"
                      placeholder="Métrica"
                      disabled={!edit && _anio !== n}
                    ></Form.Control>
                    {!!errors.descripcion && (
                      <Col>
                        <small className="text-danger">
                          {errors.descripcion}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Valor mínimo
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      id="valor_minimo"
                      name="valor_minimo"
                      isInvalid={touched.valor_minimo && errors.valor_minimo}
                      isValid={touched.valor_minimo && !errors.valor_minimo}
                      onBlur={handleBlur("valor_minimo")}
                      onChange={handleChange}
                      value={values.valor_minimo}
                      className="rounded-pill"
                      type="number"
                      placeholder="0"
                      min={0}
                      max={100}
                      disabled
                    ></Form.Control>
                    {!!errors.valor_minimo && (
                      <Col>
                        <small className="text-danger">
                          {errors.valor_minimo}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Valor máximo
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      id="valor_maximo"
                      name="valor_maximo"
                      isInvalid={
                        (touched.valor_maximo && errors.valor_maximo) ||
                        (touched.valor_maximo &&
                          parseInt(values.valor_minimo) >=
                            parseInt(values.valor_maximo))
                      }
                      isValid={
                        touched.valor_maximo &&
                        !errors.valor_maximo &&
                        parseInt(values.valor_minimo) <
                          parseInt(values.valor_maximo)
                      }
                      onBlur={handleBlur("valor_maximo")}
                      onChange={handleChange}
                      value={values.valor_maximo}
                      className="rounded-pill"
                      type="number"
                      placeholder="0"
                      min={inicialValorMinimo + 1}
                      max={100}
                      disabled={!edit && _anio !== n}
                    ></Form.Control>
                    {!!errors.valor_maximo && (
                      <Col>
                        <small className="text-danger">
                          {errors.valor_maximo}
                        </small>
                      </Col>
                    )}
                    {touched.valor_maximo &&
                      parseInt(values.valor_minimo) >=
                        parseInt(values.valor_maximo) && (
                        <Col>
                          <small className="text-danger">
                            **El valor mínimo no puede ser mayor o igual al
                            valor máximo
                          </small>
                        </Col>
                      )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Año
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      id="anio"
                      name="anio"
                      isInvalid={touched.anio && errors.anio}
                      isValid={touched.anio && !errors.anio}
                      onBlur={handleBlur("anio")}
                      onChange={handleChange}
                      value={values.anio}
                      className="rounded-pill"
                      type="number"
                      placeholder="2000"
                      min={2000}
                      disabled
                    ></Form.Control>
                    {!!errors.anio && (
                      <Col>
                        <small className="text-danger">{errors.anio}</small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Tipo de criterio
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm="12">
                        <Form.Control
                          as="select"
                          id="tipo_criterio"
                          name="tipo_criterio"
                          className="col rounded-pill"
                          isInvalid={
                            touched.tipo_criterio && errors.tipo_criterio
                          }
                          isValid={
                            touched.tipo_criterio && !errors.tipo_criterio
                          }
                          onBlur={handleBlur("tipo_criterio")}
                          value={values.tipo_criterio}
                          onChange={handleChange}
                          disabled
                        >
                          {/* <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar criterio
                          </option> */}
                          {tipoCriterio.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.desc}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>
                    {touched.tipo_criterio && errors.tipo_criterio && (
                      <Col>
                        <small className="text-danger">
                          {errors.tipo_criterio}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Coordenada
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm="12">
                        <Form.Control
                          as="select"
                          id="cordenada"
                          name="cordenada"
                          className="col rounded-pill"
                          isInvalid={touched.cordenada && errors.cordenada}
                          isValid={touched.cordenada && !errors.cordenada}
                          onBlur={handleBlur("cordenada")}
                          value={values.cordenada}
                          onChange={handleChange}
                          disabled={!edit && _anio !== n}
                        >
                          {cordenada.map((item) => (
                            <option
                              key={item.id}
                              value={item.id}
                              disabled={
                                metricNineBoxes &&
                                metricNineBoxes.data.find(
                                  (m) => m.cordenada === item.id
                                )
                              }
                            >
                              {item.desc}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>
                    {touched.cordenada && errors.cordenada && (
                      <Col>
                        <small className="text-danger">
                          {errors.cordenada}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowFormModal(false)}
                >
                  Cerrar
                </Button>
                {(!edit && _anio === n) || edit ? (
                  <Button
                    className="rounded-pill"
                    disabled={saveloaderMetricNineBoxes || filter === ""}
                    variant="primary"
                    type="submit"
                  >
                    {saveloaderMetricNineBoxes && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                ) : null}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      {/*Modal*/}
    </>
  );
};

export default MetricNineBoxes;
